import classNames from 'classnames'
import React from 'react'

import SvgSprite from 'airship/patterns/svg-sprite'

import {ParentMenuHeader} from './types'
import Popover from '../Popover'

import styles from './styles.module.css'

type Props = {
  header: ParentMenuHeader
  current: number | false
  open: boolean
  onOpen(): void
  onClose(): void
}

const MenuHeader: React.FC<Props> = ({
  header,
  current,
  open,
  onOpen,
  onClose,
}) => {
  return (
    <Popover
      displayClasses={styles.popoverBody}
      isOpen={open}
      onClose={onClose}
      noArrow
      targetElement={
        <li className={styles.navigationItem} onClick={onOpen}>
          <a
            className={classNames(styles.link, {
              [`${styles.current}`]: current !== false,
            })}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : 'false'}
          >
            {header.label}
            <SvgSprite name="caret-down" displayClasses={styles.caret} />
          </a>
        </li>
      }
    >
      <ul className={styles.menu}>
        {header.children.map((item, index) => {
          if (item.hidden) return
          return (
            <li className={styles.menuItem} key={'item_' + item.label}>
              <a
                className={classNames(styles.subLink, {
                  [`${styles.current}`]: current === index,
                })}
                href={item.url}
              >
                {item.label}
              </a>
            </li>
          )
        })}
      </ul>
    </Popover>
  )
}

export default MenuHeader
